// export const BRAND_NAME = 'KiaFair';
// export const BRAND_DOMAIN = 'admin.kiafair.com';
// export const TEMP_DOMAIN = 'hypexone.com';

export const BRAND_NAME = 'Sky11';
export const BRAND_DOMAIN = 'sky11.live';

export const OPERATORID = 'HypexDemo';
export const PROVIDER_ID = 'BetFair';
